// components/features/modules/ModuleRow.tsx

import { Module } from "../../../types/features/Module";
import TableRow from "../../ui/TableRow";
import { Phone, Ticket, MessageSquare, Mail, Smartphone } from "lucide-react";

interface ModuleRowProps {
  module: Module;
  onAction: (module: Module) => void;
  onSelect?: (module: Module, isSelected: boolean) => void;
  isSelected?: boolean;
  selectable?: boolean;
}

const getModuleIcon = (key: string) => {
  const icons: { [key: string]: any } = {
    tickets: Ticket,
    calls: Phone,
    whatsapp: MessageSquare,
    email: Mail,
    sms: Smartphone,
  };
  return icons[key] || Ticket;
};

export default function ModuleRow({
  module,
  onAction,
  onSelect,
  isSelected = false,
  selectable = false
}: ModuleRowProps) {
  const IconComponent = getModuleIcon(module.key);

  return (
    <TableRow
      item={module}
      onAction={onAction}
      onSelect={onSelect}
      isSelected={isSelected}
      selectable={selectable}
      actionable={true}
    >
      {/* Colonne Module */}
      <td className="py-3 px-4">
        <div className="flex items-center space-x-3">
          <div className={`h-9 w-9 rounded-lg flex items-center justify-center shrink-0 ${
            module.is_active ? 'bg-primary/10 text-primary' : 'bg-gray-100 text-gray-400'
          }`}>
            <IconComponent size={18} />
          </div>
          <div>
            <span className="text-sm font-medium text-gray-900 block">
              {module.name}
            </span>
            {module.description && (
              <span className="text-xs text-gray-500 block truncate max-w-[200px]">
                {module.description}
              </span>
            )}
          </div>
        </div>
      </td>

      {/* Colonne Clé */}
      <td className="hidden sm:table-cell py-3 px-4 whitespace-nowrap">
        <span className="text-xs text-gray-500 font-mono">
          {module.key}
        </span>
      </td>

      {/* Colonne Statut */}
      <td className="hidden md:table-cell py-3 px-4 whitespace-nowrap">
        <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium ${
          module.is_active
            ? 'bg-green-100 text-green-800'
            : 'bg-gray-100 text-gray-500'
        }`}>
          {module.is_active ? 'Actif' : 'Inactif'}
        </span>
      </td>

      {/* Colonne Date de création */}
      <td className="hidden xl:table-cell py-3 px-4 whitespace-nowrap">
        <span className="text-xs text-gray-500">
          {module.created_at
            ? new Date(module.created_at).toLocaleDateString("fr-FR", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric"
              })
            : "—"}
        </span>
      </td>
    </TableRow>
  );
}